// extracted by mini-css-extract-plugin
export default {"asyncWaitingPage":"axnui-async-waiting-page__async-waiting-page__CNaey","textSpan":"axnui-async-waiting-page__text-span__lZZ31"};